<template>
  <div>
    <div class="card-grid-display">
      <v-card
        class="mx-auto agenda-meeting-card"
        width="100%"
        elevation="0"
        :to="`/meeting/${data.id}/agenda/tenant/${tenantId}`"
        flat
      >
        <v-card-text class="card-grid-display">
          <v-row no-gutters>
            <v-col cols="3" sm="3" md="3" lg="3">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="text-subtitle-1 font-weight-bold primary--text"
                    v-html="
                      getMeetingScheduleDetails(data.scheduletStartTimeInUTC)
                    "
                  ></span>
                </template>
                <span>{{ $t("agenda.lblStartTime") }}</span>
              </v-tooltip>
            </v-col>
            <v-col
              cols="2"
              sm="2"
              md="2"
              lg="2"
              class="d-flex align-center justify-center"
            >
              <span
                class="font-weight-bold"
                style="font-size: 21px; color: var(--v-primary-base)"
                >-</span
              >
            </v-col>
            <v-col cols="5" sm="5" md="5" lg="5">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="text-subtitle-1 font-weight-bold primary--text"
                    v-html="
                      getMeetingScheduleDetails(data.scheduledEndTimeInUTC)
                    "
                  ></span>
                </template>
                <span>{{ $t("agenda.lblEndTime") }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4" sm="4" md="4" lg="4">
              <span class="text-body-2">{{ $t("search.meetingName") }}: </span>
            </v-col>
            <v-col cols="8" sm="8" md="8" lg="8">
              <span
                class="text-body-2"
                style="word-break: break-word"
                v-text="getMeetingName(data)"
              ></span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4" sm="4" md="4" lg="4">
              <span class="text-body-2"
                >{{ $t("agenda.lblMeetingLocation") }}:
              </span>
            </v-col>
            <v-col cols="8" sm="8" md="8" lg="8">
              <span class="text--topic text-body-2">
                {{ data.location }}
              </span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4" sm="4" md="4" lg="4">
              <span class="text-body-2"
                >{{ $t("agenda.lblMeetingType") }}:
              </span>
            </v-col>
            <v-col cols="8" sm="8" md="8" lg="8">
              <span class="text--topic text-body-2">{{
                data.meetingType.label
              }}</span>
            </v-col>
          </v-row>
          <v-row no-gutters v-if="documentsList.length > 0">
            <agenda-document-list
              :documents="documentsList"
              :hasTopic="true"
              :title="data.meetingName"
            >
            </agenda-document-list>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import customFunctions from "@/codeFiles/taskHelper.js";
import AgendaViewDocumentList from "./AgendaViewDocumentList.vue";
import AgendaDocumentList from "./AgendaDocumentList.vue";
import { Internationalization } from "@syncfusion/ej2-base";
import { mapActions } from "vuex";
import { openDocument, formatDate } from "@/utils/util.js";
export default {
  components: { AgendaViewDocumentList, AgendaDocumentList },
  name: "AgendaViewGridMeetingRowTemplate",
  data() {
    return {
      data: {},
      intl: new Internationalization(),
      formatDate,
    };
  },
  computed: {
    isDarkTheme() {
      return customFunctions.getContrast(this.data.meetingType.color);
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
    documentsCount() {
      const total = this.data.topics
        .map((d) => d.documents.length)
        .reduce((partialSum, a) => partialSum + a, 0);
      return total;
    },
    momDocuments() {
      return this.data.momDocuments
        ? this.data.momDocuments.map((obj) => ({
            ...obj,
            topicName: this.$t("agenda.lblMOM"),
          }))
        : [];
    },
    generalDocuments() {
      return this.data.generalMeetingDocs
        ? this.data.generalMeetingDocs.map((obj) => ({
            ...obj,
            topicName: this.$t("documents.lblGenDoc"),
          }))
        : [];
    },
    documentsList() {
      const topicDocument = [].concat.apply(
        [],
        this.data.topics.map((d) =>
          d.documents.map((obj) => ({
            ...obj,
            topicName: `${this.$t("documents.topic")}: ${d.topicName}`,
          }))
        )
      );
      return [...topicDocument, ...this.generalDocuments, ...this.momDocuments];
    },
    meetingTypeId() {
      return this.data.meetingType.id;
    },
    openMeetingDocumentPermission() {
      if (this.meetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.meetingTypeId,
          "OpenMeetingDocument"
        );
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      downloadDocumentAPI: "document/downloadDocument",
      addDocumentView: "document/addDocumentView",
    }),
    getMeetingName(obj) {
      if (obj.meetingName.length > 100) {
        return obj.meetingName.slice(0, 100) + "...";
      } else {
        return obj.meetingName;
      }
    },
    documentListPopup() {
      return false;
    },
    clip(str) {
      const limit = 50;
      if (!str) return "";
      str = str.toString();

      if (str.length <= limit) {
        return str;
      }
      return str.substr(0, limit) + "...";
    },
    async documentDownload(item) {
      const params = {
        documentId: item.documentId,
        filename: item.fileName,
      };
      const res = await this.downloadDocumentAPI(params);
      var contentType = res.headers["content-type"];
      var blob = new Blob([res.data], { type: contentType });
      var url = window.URL.createObjectURL(blob);
      this.activeDocument = {
        ...this.activeDocument,
        ...{ [item.documentId]: true },
      };

      this.addDocumentView(item.documentId);
      openDocument(url, item.fileName);
    },
    getTimeDetails(mDetails) {
      const Xmas95 = new Date(mDetails.scheduletStartTimeInUTC);
      const endDate = new Date(mDetails.scheduledEndTimeInUTC);
      const dateTemp = new Intl.DateTimeFormat(this.selectedLang, {
        dateStyle: "full",
        timeStyle: "long",
      }).format(Xmas95);
      const startDate = new Intl.DateTimeFormat(this.selectedLang, {
        dateStyle: "long",
      }).format(Xmas95);
      const startTime = new Intl.DateTimeFormat(this.selectedLang, {
        timeStyle: "short",
      }).format(Xmas95);
      const endTime = new Intl.DateTimeFormat(this.selectedLang, {
        timeStyle: "short",
      }).format(endDate);
      const d = Xmas95.getDate();
      const day = d < 10 ? `0${d}` : d;
      const m = Xmas95.getMonth() + 1; //Month from 0 to 11
      const month = m < 10 ? `0${m}` : m;
      const y = Xmas95.getFullYear();
      return `${y}/${month}/${day} <br> ${startTime} - ${endTime}`;
    },
    getMeetingScheduleDetails(scheduletTime) {
      const date = new Date(scheduletTime);
      const time = new Intl.DateTimeFormat(this.selectedLang, {
        timeStyle: "short",
      }).format(date);

      const d = date.getDate();
      const day = d < 10 ? `0${d}` : d;
      const m = date.getMonth() + 1; //Month from 0 to 11
      const month = m < 10 ? `0${m}` : m;
      const y = date.getFullYear();
      return `${y}/${month}/${day} <br> ${time}`;
    },
    showMeetingDayPage(mDetails) {
      this.$router.push(
        "/meeting/" + mDetails.id + "/agenda/tenant/" + this.tenantId
      );
    },
    getDateInternationalDate(dateString) {
      var Xmas95 = new Date(dateString);
      var options = { dateStyle: "full", timeStyle: "short" };
      return new Intl.DateTimeFormat(this.selectedLang, options).format(Xmas95);
    },
  },
};
</script>

<style scoped>
.v-tooltip {
  z-index: 1 !important;
}
::v-deep .surveydates {
  color: white;
}
.agenda-meeting-card .v-card__text {
  padding: 16px !important;
  color: var(--v-darkCharcoal-base) !important;
}
.card-grid-display {
  display: grid;
  grid-gap: 8px;
}
</style>